module.exports = __webpack_public_path__ + "img/9791187312000.f150849c.jpg";